import $ from 'jquery';

$("[data-backup]").keyup(function (event) {
    $(event.target).data("valueBackup", $(event.target).val());
});

$("form").on("reset", function () {
    setTimeout(
        function () {
            $.each($("[data-backup]"), function (index, obj) {
                $(obj).val($(obj).data("valueBackup"));
            });
        },
        100
    );
});
